import React from "react";

export default function DropdownPager(props: {
	totalPages: number;
	onPageChange: (value: number) => void;
	pageNumber: number;
}) {
	const optionsArray = [];

	for (let i = 1; i <= props.totalPages; i++) {
		optionsArray.push(i);
	}

	return (
		<select
			className="pagination__input pagination--wrap__input input input--sml input--select"
			onChange={(e) => props.onPageChange(parseInt(e.target.value) || 1)}
			value={props.pageNumber}
		>
			{optionsArray.map((pageNr) => (
				<option key={pageNr} value={pageNr}>
					{pageNr}
				</option>
			))}
		</select>
	);
}
